var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumMonitor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "#1790FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.213501,
    y: 0.632965,
    width: 21.794,
    height: 22.7416,
    rx: 3,
    fill: "#FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74158 18.6367C8.74158 18.1134 9.16582 17.6892 9.68914 17.6892H13.4794C14.0027 17.6892 14.427 18.1134 14.427 18.6367C14.427 19.1601 14.0027 19.5843 13.4794 19.5843H9.68914C9.16582 19.5843 8.74158 19.1601 8.74158 18.6367Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5843 15.794C12.1076 15.794 12.5319 16.2183 12.5319 16.7416L12.5319 20.5319C12.5319 21.0552 12.1076 21.4794 11.5843 21.4794C11.061 21.4794 10.6367 21.0552 10.6367 20.5319L10.6367 16.7416C10.6367 16.2183 11.061 15.794 11.5843 15.794Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05615 5.47568C3.05615 4.37111 3.95158 3.47568 5.05615 3.47568H17.1648C18.2693 3.47568 19.1648 4.37111 19.1648 5.47568V12.8465C19.1648 13.951 18.2693 14.8465 17.1648 14.8465H5.05615C3.95158 14.8465 3.05615 13.951 3.05615 12.8465V5.47568Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumMonitor);
export default __webpack_public_path__ + "static/media/numMonitor.911b8385.svg";
export { ForwardRef as ReactComponent };